<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <input type="hidden" v-model="form.id" />
      <el-form-item label="产品标题">
        <el-input v-model="form.pro_title"></el-input>
      </el-form-item>
      <el-form-item label="所属栏目">
        <el-select v-model="form.cate_id"  placeholder="请选择">
          <el-option
              v-for="item in cateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input   v-model="form.pro_key" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" :rows="2"  v-model="form.pro_info" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="路由">
        <el-input v-model="form.pro_route" placeholder="文章链接会根据路由更改"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="setRoute()">自动获取</el-button>
      </el-form-item>
      <el-form-item label="seo标题">
        <el-input v-model="form.seo_title"></el-input>
      </el-form-item>
      <el-form-item label="seo关键词">
        <el-input v-model="form.seo_keyword"></el-input>
      </el-form-item>
      <el-form-item label="seo简介">
        <el-input v-model="form.seo_info"></el-input>
      </el-form-item>
      <el-form-item label="H1标题">
        <el-input v-model="form.pro_h1"></el-input>
      </el-form-item>
      <el-form-item label="结构化数据">
        <el-input type="textarea" :rows="2"  v-model="form.pro_schema" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="作者">
        <el-input v-model="form.pro_writer"></el-input>
      </el-form-item>
      <el-form-item label="缩略图">
        <el-upload
            class="upload-demo"
            action="/api/Upload/upload.html"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :file-list="form.fileList"
            list-type="picture"
            :data="{'field':'pro_img'}"
            :limit="1"
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_img" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="轮播图">
        <el-upload
            ref="upload"
            class="upload-demo"
            multiple
            action="/api/Upload/upload.html"
            :on-preview="handlePreview1"
            :on-remove="handleRemove1"
            :on-success="handleAvatarSuccess1"
            :file-list="form.fileList1"
            list-type="picture-card"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_imglist" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="分类简介">
        <el-input type="textarea" :rows="4"  v-model="form.pro_cate" placeholder="分类名称|分类信息"></el-input>
      </el-form-item>
<!--      <el-form-item label="提问回答">-->
<!--        <el-input type="textarea" :rows="6"  v-model="form.pro_problem" placeholder="提问|回答"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="正文">
        <div style="border: 1px solid #ccc;">
          <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
          />
          <Editor
              style="height: 500px; overflow-y: hidden;"
              v-model="form.pro_content"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
          />
        </div>
      </el-form-item>
      <el-form-item label="正文图片">
        <el-upload
            class="upload-demo"
            multiple
            action="/api/Upload/upload.html"
            :on-preview="handlePreview4"
            :on-remove="handleRemove4"
            :on-success="handleAvatarSuccess4"
            :file-list="form.fileList4"
            list-type="picture-card"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_contentimg" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="正文2">
        <div style="border: 1px solid #ccc;">
          <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor2"
              :defaultConfig="toolbarConfig"
              :mode="mode"
          />
          <Editor
              style="height: 500px; overflow-y: hidden;"
              v-model="form.pro_contents"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreateds"
          />
        </div>
      </el-form-item>
<!--      <el-form-item label="视频">-->
<!--        <div style="border: 1px solid #ccc;">-->
<!--          <Toolbar-->
<!--              style="border-bottom: 1px solid #ccc"-->
<!--              :editor="editor2s"-->
<!--              :defaultConfig="toolbarConfig"-->
<!--              :mode="mode"-->
<!--          />-->
<!--          <Editor-->
<!--              style="height: 500px; overflow-y: hidden;"-->
<!--              v-model="form.pro_contentss"-->
<!--              :defaultConfig="editorConfig"-->
<!--              :mode="mode"-->
<!--              @onCreated="onCreatedss"-->
<!--          />-->
<!--        </div>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="产品附件">-->
<!--        <el-upload-->
<!--            class="upload-demo"-->
<!--            action="/api/Upload/fileupload.html"-->
<!--            :on-preview="handlePreview2"-->
<!--            :on-remove="handleRemove2"-->
<!--            :on-success="handleAvatarSuccess2"-->
<!--            :file-list="form.fileList2"-->
<!--            list-type="text"-->
<!--            :limit=50-->
<!--            name="image[]"-->
<!--        >-->
<!--          <el-button size="small" type="primary">点击上传</el-button>-->
<!--          <div slot="tip" class="el-upload__tip">-->
<!--            文件不超过50Mb-->
<!--          </div>-->
<!--        </el-upload>-->
<!--        <el-input v-model="form.pro_file" type="hidden"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="产品标签">-->
<!--        <el-input v-model="form.pro_label" placeholder="标签|标签"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="关联产品">
        <el-input v-model="form.pro_pro" placeholder="1,2"></el-input>
      </el-form-item>
      <el-form-item label="外部链接">
        <el-input v-model="form.islink"></el-input>
      </el-form-item>
<!--      <el-form-item label="添加时间">-->
<!--        <el-date-picker-->
<!--            value-format="yyyy:MM:dd HH:mm:ss"-->
<!--            v-model="form.release_time"-->
<!--            type="date"-->
<!--            placeholder="选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
      <el-form-item label="发布时间">
        <el-date-picker
            value-format="yyyy:MM:dd HH:mm:ss"
            v-model="form.release_time"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.top" :min="0" :max="100" label=""></el-input-number>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.pro_status">
          <el-radio-button label="0">未审核</el-radio-button>
          <el-radio-button label="1">正常</el-radio-button>
          <el-radio-button label="2">推荐</el-radio-button>
          <el-radio-button label="3">暂停</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose">重置</el-button>
      </el-form-item>
    </el-form>
    <Dialog  :url='url' :show.sync="dialogVisible" @dialogShowChange="dialogShowChange"></Dialog>
  </div>
</template>
<script>
import axios from "axios";
import Dialog from "@/views/pages/getFileView.vue";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import Sortable from 'sortablejs';

export default {
  name: "getProductView",
  components:{Dialog , Editor, Toolbar},
  data(){
    return{
      url: '',
      dialogVisible: false,
      form: {
        id: "",
        cate_id: "",
        pro_title: "",
        pro_img: "",
        pro_writer: "",
        pro_problem: "",
        pro_key: "",
        top: 0,
        release_time: '',
        pro_cate: '',
        pro_label: '',
        pro_pro: '',
        pro_case: '',
        pro_route: "",
        pro_info:'',
        islink: '',
        pro_content: '',
        pro_contents: '',
        pro_contentss: '',
        pro_imglist: '',
        pro_file: '',
        fileList:[],
        fileList1:[],
        fileList2:[],
        // Contentexp:[],
        pro_status: 0
      },
      cateList: [],
      typeList: [],
      wayList: [],
      editor: null,
      editor2: null,
      editor2s: null,
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF:{
          'uploadImage' : {
            // customUpload: this.uploadImg,
            server: '/api/Upload/uploadEditor.html',
            fieldName: 'image[]',
            maxFileSize: 2 * 1024 * 1024, // 2M
            maxNumberOfFiles: 50,
            allowedFileTypes: ['image/*'],
            timeout: 5 * 1000, // 5 秒
          },
          'uploadVideo':{
            // customUpload: this.uploadImg,
            server: '/api/Upload/editorFile.html',
            withCredentials: true,
            fieldName: 'files[]',
            maxFileSize: 200 * 1024 * 1024, // 200M
            // maxNumberOfFiles: 3,
            // allowedFileTypes: ['video/*'],
            // timeout: 15 * 1000, // 5 秒
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  // created() {
  //   this.getCategory();
  // },
  mounted() {
    let geturl = window.location.href;
    let geturlinfo = geturl.split('?')[1];
    let getqys = new URLSearchParams('?'+geturlinfo);
    let id = getqys.get('id');
    console.log(id);
    axios.get('/api/Category/easyList.html').then((res)=>{
      this.cateList = res.data;
    });

    axios.get('/api/Type/index.html?type=type').then((res)=>{
      this.typeList = res.data;
    });
    axios.get('/api/Type/index.html?type=way').then((res)=>{
      this.wayList = res.data;
    });
    if(id > 0){
      axios.get('/api/Product/getProduct.html?id='+id).then((res)=>{
        if(res.data.code == 200){
          this.form = res.data.data;
        }
      });
    }else{
      // this.form.release_time = Date.now();
    }

    this.initDragSort();

  },

  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods:{
    initDragSort(){
      const el = this.$refs.upload.$el.querySelectorAll('.el-upload-list')[0];
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          console.log(oldIndex);
          console.log(newIndex);
          // 交换位置
          let img = this.form.pro_imglist;
          var imglist = [];
          if(img) imglist = img.split(',');
          const page = imglist[oldIndex];
          imglist.splice(oldIndex, 1);
          imglist.splice(newIndex, 0, page);
          this.form.pro_imglist = imglist.join(',');
        }
      });
    },
    dialogShowChange(val){
      this.dialogVisible = val
    },
    setRoute(){
      var input = this.form.pro_title;
      var sanitizedVal = input.replace(/[^\w\s-]/g, '').replace(/[\s]/g, '-').toLowerCase();
      this.form.pro_route = sanitizedVal;
    },
    expurl(url){
      url = url.split('upload/');
      return url[1];
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreateds(editor2) {
      this.editor2 = Object.seal(editor2) // 一定要用 Object.seal() ，否则会报错
    },
    onCreatedss(editor2s) {
      this.editor2s = Object.seal(editor2s) // 一定要用 Object.seal() ，否则会报错
    },
    resetData(){
      this.form = this.$options.data().form;
    },
    handleClose() {
      this.resetData()
    },
    handleAvatarSuccess(res,f,ff) {
      console.log(f);
      console.log(ff);
      let array = Object.values(res);
      this.form.pro_img = array[0]['file_url'];
    },
    handleChange(value) {
      console.log(value);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleAvatarSuccess1(res) {
      let array = Object.values(res);
      let img = this.form.pro_imglist;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_imglist = imglist.join(',');
    },
    handleAvatarSuccess4(res) {
      let array = Object.values(res);
      let img = this.form.pro_contentimg;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_contentimg = imglist.join(',');
    },
    handleRemove1(file, fileList) {
      let img = this.form.pro_imglist;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        var str = imglist[i].replace(/\\/g,'/');
        if(str == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_imglist = imglist.join(',');
      console.log(fileList);
    },
    handleRemove4(file, fileList) {
      let img = this.form.pro_contentimg;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        var str = imglist[i].replace(/\\/g,'/');
        if(str == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_contentimg = imglist.join(',');
      console.log(fileList);
    },
    handlePreview1(file) {
      console.log(file);
    },
    handlePreview4(file) {
      var thisurl = file.img;
      if(!thisurl) thisurl = file.response[0].file_url;
      this.url = thisurl;
      this.dialogVisible =true
    },
    handleAvatarSuccess2(res) {
      let array = Object.values(res);
      let img = this.form.pro_file;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_file = imglist.join(',');
    },
    handleRemove2(file, fileList) {
      let img = this.form.pro_file;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_file = imglist.join(',');
      console.log(fileList);
    },
    handlePreview2(file) {
      console.log(file);
    },
    onSubmit() {
      axios({
        method:'post',
        url:'/api/Product/setProduct.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {
          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          // this.$props.id = res.data.id;
          this.form.id = res.data.id;
          // this.$router.go(0);
        }
      })
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
  .haf{
    width: 20%;
    margin-right: 10px;
  }
  .hafs{
    width: 10%;
  }
</style>